<template>
  <Menu.Root v-if="actions.length !== 0" id="row-actions">
    <Menu.Trigger>
      <button
        type="button"
        aria-label="Actions"
        class="-m-1 grid place-items-center rounded-full p-1 text-gray-700 outline-2 -outline-offset-1 outline-blue-500 focus-visible:outline dark:text-muted-foreground"
      >
        <EllipsisHorizontalIcon class="size-4" />
      </button>
    </Menu.Trigger>

    <Menu.Container>
      <template v-for="(item, idx) in actions" :key="idx">
        <Menu.Item
          v-if="item.type === 'action'"
          :id="item.id"
          :icon="item.icon"
          :label="item.label"
          :variant="item.variant"
          :disabled="item.disabled"
          @click="item.onClick"
        />
        <Menu.RouteItem
          v-else-if="item.type === 'route'"
          :id="item.id"
          :icon="item.icon"
          :label="item.label"
          :variant="item.variant"
          :disabled="item.disabled"
          :to="item.to"
        />
        <Menu.LinkItem
          v-else-if="item.type === 'link'"
          :id="item.id"
          :icon="item.icon"
          :label="item.label"
          :href="item.href"
        />
        <Menu.Divider v-else-if="item.type === 'divider'" />
        <Menu.Submenu
          v-else-if="item.type === 'submenu'"
          :label="item.label"
          :icon="item.icon"
        >
          <MenuSubmenuItems :actions="item.desktop" />
        </Menu.Submenu>
      </template>
    </Menu.Container>
  </Menu.Root>
</template>

<script setup lang="ts">
import { computed } from "vue";

import Menu from "@/design_system/Menu";
import EllipsisHorizontalIcon from "@/icons/heroicons/ellipsis-horizontal-micro.svg";

import type { ActionItem } from "../types/overflow";
import MenuSubmenuItems from "./MenuSubmenuItems.vue";

const props = defineProps<{
  registrar: () => ActionItem[];
}>();

const actions = computed(() => {
  return props.registrar();
});
</script>
